import { render } from "./aboutFoundation.vue?vue&type=template&id=44d7bed2"
import script from "./aboutFoundation.vue?vue&type=script&lang=js"
export * from "./aboutFoundation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__